import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

/*
 * Template Implementation Example
 *
 * <!-- Button to activate modal -->
 * <button type="button" class="btn btn-primary" (click)="confirmBeforeAuthorizingPayment()">Save</button>
 *
 * <!-- Modal component -->
 * <pioneer-confirmation-modal (closed)="confirmHandler($event)"></pioneer-confirmation-modal>
 *
 *
 * Component Implementation Example
 *
 * import { Component, OnInit, ViewChild } from '@angular/core';
 * import { ModalDirective } from 'ngx-bootstrap/modal';
 * import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
 * @Component({
 *  selector: 'pioneer-example',
 *  templateUrl: './example.component.html'
 * })
 * export class ExampleComponent {
 *   @ViewChild(ConfirmationModalComponent)
 *   public confirmationModal: ConfirmationModalComponent;
 *
 *   public confirmBeforeAuthorizingPayment(): void {
 *     this.confirmationModal.open();
 *   }
 *
 *   public confirmHandler(value) {
 *     if (value) {
 *       this.save();
 *     }
 *   }
 *
 *   public save() {
 *     ...
 *   }
 * }
 */

@Component({
  selector: 'pioneer-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent implements OnInit {

  @Input()
  public cancel = 'COMMON.BUTTON.DISCARD';

  @Input()
  public confirm = 'COMMON.BUTTON.CONTINUE';

  @Input()
  public title = 'MESSAGES.CONFIRMATION.EXIT_TITLE';

  @Input()
  public content = 'MESSAGES.CONFIRMATION.EXIT_MESSAGE';

  @Input()
  public confirmClass = 'inherit';

  @Input()
  public config = {
    backdrop: 'static'
  };

  @Output()
  public closed = new EventEmitter<string | boolean>();

  @ViewChild(ModalDirective)
  public confirmationModal: ModalDirective;

  get isShown(): boolean { return this.confirmationModal.isShown; }

  @Input() action: string | boolean = true;

  @Input() customModal = false;

  @Input() customContent = false;

  constructor() {
  }

  ngOnInit() {
  }

  public open(): void {
    this.confirmationModal.show();
  }

  /**
   * Closes the confirmation modal upon accept or cancel.
   * @deprecated Use `onAccept` or `onCancel` instead.
   * @param value - The value indicating whether the action is accepted or cancelled.
   */
  public close(value: boolean): void {
    if (value) {
      this.onAccept();
    } else {
      this.onCancel();
    }
  }

  onAccept() {
    this.closed.emit(this.action);
    this.confirmationModal.hide();
  }

  onCancel() {
    this.closed.emit(false);
    this.confirmationModal.hide();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal.component.ts